import React from "react";
import { useTheme } from "../../context/ThemeContext";

import TickIcon from "../../images/icons/tick-dark.inline.svg";
import TickIconLight from "../../images/icons/tick-icon-light.inline.svg";
import ListNestedTextCard from "../cards/listNestedTextCard";

const TravelFlexibility = ({
  travelDetails = {},
  isGVI = false,
  hasBullets = false,
  outerContainerClass = "border-0.5 sm:h-full my-6 bg-black-lighter dark:bg-transparent",
  innerContainerClass = "gap-4 p-6 bg-black-lighter bg-transparent dark:bg-transparent",
  headingClass = "h3",
  descriptionClass = "description text-xs text-black-lighter dark:text-gray-generic",
  listItemClass = "",
  nestedListItemClass = "",
  iconClass = ""
}) => {
  const { colorMode } = useTheme();

  const Icon = colorMode === "light" || !isGVI ? TickIconLight : TickIcon;

  const renderBullets = (bulletList) => (
    <ListNestedTextCard
      list={bulletList?.items}
      listItemClass={listItemClass}
      nestedListItemClass={nestedListItemClass}
      isGVI={isGVI}
      iconClass={iconClass}
    />
  );

  return (
    <div
      className={`border-gray-testimonial rounded-xs sm:rounded-xs flex items-center flex-col sm:flex-row overflow-hidden ${outerContainerClass}`}
    >
      <div
        className={`flex flex-col items-start flex-1 w-full rounded-b ${innerContainerClass}`}
      >
        <div className="w-full">
          <div
            className={headingClass}
            dangerouslySetInnerHTML={{ __html: travelDetails?.title }}
          />
        </div>
        {hasBullets ? (
          renderBullets(travelDetails)
        ) : (
          <div className="travel-flexibility flex justify-between sm:py-1">
            <Icon className="w-4 md:w-6 h-4 md:h-6 dark:stroke-gray-generic hidden" />
            <div
              className={descriptionClass}
              dangerouslySetInnerHTML={{
                __html: travelDetails?.description
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default TravelFlexibility;
